import React from 'react';

import styled from '@emotion/styled';

interface DriverCardProps {
  data: any;
}
const DriverCard: React.FC<DriverCardProps> = ({ data }) => {
  return (
    <Container>
      <Img
        src={data.profilePicture ?? '/static/img/profilePlaceholder2.png'}
        alt='Rider Avatar'
      />
      <div>
        {data.name.split(' ')[0].charAt(0).toUpperCase() +
          data.name.split(' ')[0].slice(1).toLowerCase()}{' '}
        {data.name.split(' ')[1]?.charAt(0).toUpperCase() +
          data.name.split(' ')[1]?.slice(1).toLowerCase()}
      </div>
    </Container>
  );
};

export default DriverCard;

const Container = styled.div`
  display: flex;
  gap: 12px;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
`;

const Img = styled.img`
  width: 32px;
  height: 32px;
  /* border-radius: 8px; */
`;
